const createAnonymousId = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const getSentryAnonymousUserGuid = (): string => {
    try {
        const existingUserId = localStorage.getItem('sentry-user-id');

        if (existingUserId) {
            return existingUserId;
        }

        const userId = createAnonymousId();
        localStorage.setItem('sentry-user-id', userId);
        return userId;
    } catch {
        return createAnonymousId();
    }
};

export const createSentryAnonymousUser = () => {
    const userGuid = getSentryAnonymousUserGuid();
    const anonymousUser = `Anonymous - ${userGuid}`;

    return {
        id: anonymousUser,
        username: anonymousUser,
        fullName: 'Anonymous User',
    };
};
